import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-004a63eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-beta-screen",
  role: "presentation"
}
const _hoisted_2 = {
  ref: "panelEl",
  class: "nge-beta-panel",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "nge-beta-title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-beta-kicker" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-beta-dot",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode("Closed beta")
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "nge-beta-title",
  class: "nge-beta-title"
}, "Pyr is invite only for now", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-beta-text" }, "Thanks for signing in! Pyr is in a closed beta while we get it ready. Ask to join and we'll add you as soon as we can.", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "nge-beta-label",
  for: "nge-beta-name"
}, "Your name", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "nge-beta-label",
  for: "nge-beta-email"
}, "Your email", -1 /* HOISTED */))
const _hoisted_8 = { class: "nge-beta-pair" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "nge-beta-label",
  for: "nge-beta-ewname"
}, [
  /*#__PURE__*/_createTextVNode("EyeWire username "),
  /*#__PURE__*/_createElementVNode("span", null, "(optional)")
], -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "nge-beta-label",
  for: "nge-beta-ewrank"
}, [
  /*#__PURE__*/_createTextVNode("EyeWire rank "),
  /*#__PURE__*/_createElementVNode("span", null, "(optional)")
], -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "nge-beta-label",
  for: "nge-beta-note"
}, [
  /*#__PURE__*/_createTextVNode("Anything you'd like us to know? "),
  /*#__PURE__*/_createElementVNode("span", null, "(optional)")
], -1 /* HOISTED */))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "nge-beta-error",
  role: "alert"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-beta-text nge-beta-text--done" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-beta-check",
    "aria-hidden": "true"
  }, "✓"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "nge-beta-thanks" }, "Thanks for requesting early access to map the brain! We'll let you know by email when you're in."),
    /*#__PURE__*/_createElementVNode("p", { class: "nge-beta-sign" }, "The Pyr (pronounced \"peer\") team at Princeton University")
  ])
], -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-beta-label" }, "While you wait", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "nge-beta-links" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://eyewire.org",
      target: "_blank",
      rel: "noreferrer"
    }, "Play EyeWire"),
    /*#__PURE__*/_createTextVNode(", the original brain mapping game, right in your browser.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://connectome.quest/learn.html",
      target: "_blank",
      rel: "noreferrer"
    }, "Neuro 101"),
    /*#__PURE__*/_createTextVNode(", a guided zoom from a whole brain down to a single neuron.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://connectome.quest/atlas/",
      target: "_blank",
      rel: "noreferrer"
    }, "Connectome 101"),
    /*#__PURE__*/_createTextVNode(", what a connectome is and how scientists map one.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://connectome.quest/videos.html",
      target: "_blank",
      rel: "noreferrer"
    }, "Neuron videos"),
    /*#__PURE__*/_createTextVNode(", animations of real neurons from mouse and fly brains.")
  ])
], -1 /* HOISTED */))
const _hoisted_17 = { class: "nge-beta-foot" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-beta-sep",
  "aria-hidden": "true"
}, "·", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($setup.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            (!$setup.requested)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _hoisted_6,
                  _withDirectives(_createElementVNode("input", {
                    id: "nge-beta-name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.name) = $event)),
                    class: "nge-beta-field",
                    type: "text",
                    maxlength: "80",
                    autocomplete: "name",
                    onInput: _cache[1] || (_cache[1] = $event => ($setup.error = ''))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.name]
                  ]),
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    id: "nge-beta-email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.email) = $event)),
                    class: "nge-beta-field",
                    type: "email",
                    maxlength: "254",
                    autocomplete: "email",
                    onInput: _cache[3] || (_cache[3] = $event => ($setup.error = ''))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.email]
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _withDirectives(_createElementVNode("input", {
                        id: "nge-beta-ewname",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.ewName) = $event)),
                        class: "nge-beta-field",
                        type: "text",
                        maxlength: "60",
                        autocomplete: "off",
                        spellcheck: "false",
                        onInput: _cache[5] || (_cache[5] = $event => ($setup.error = ''))
                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                        [_vModelText, $setup.ewName]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("input", {
                        id: "nge-beta-ewrank",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.ewRank) = $event)),
                        class: "nge-beta-field",
                        type: "text",
                        maxlength: "40",
                        autocomplete: "off",
                        onInput: _cache[7] || (_cache[7] = $event => ($setup.error = ''))
                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                        [_vModelText, $setup.ewRank]
                      ])
                    ])
                  ]),
                  _hoisted_11,
                  _withDirectives(_createElementVNode("textarea", {
                    id: "nge-beta-note",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.note) = $event)),
                    class: "nge-beta-note",
                    rows: "2",
                    maxlength: "500",
                    placeholder: "Where you heard about Pyr"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.note]
                  ]),
                  _createElementVNode("button", {
                    class: "nge-beta-btn",
                    disabled: $setup.sending,
                    onClick: $setup.request
                  }, _toDisplayString($setup.sending ? 'Sending...' : 'Request beta access'), 9 /* TEXT, PROPS */, _hoisted_12),
                  ($setup.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString($setup.error), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" Ames 2026-10-26: the thanks, the sign off, and things to do meanwhile. "),
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16
                ], 64 /* STABLE_FRAGMENT */)),
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode(" Questions? Email "),
              _createElementVNode("a", {
                href: 'mailto:' + $setup.SUPPORT
              }, _toDisplayString($setup.SUPPORT), 8 /* PROPS */, _hoisted_18),
              _hoisted_19,
              _createElementVNode("button", {
                class: "nge-beta-link",
                onClick: $setup.signOut
              }, "Sign out")
            ])
          ], 512 /* NEED_PATCH */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}